import * as React from 'react';
import {Paper, Typography} from "@mui/material";

const QuestionSequenceSolution = ({question}) => {
    return (
        <>
            {question.answers.map(option =>
                <Paper elevation={3}
                       sx={{my: 1, mx: .5, p: 1}}
                >
                    <Typography unselectable>
                        {option.content}
                    </Typography>
                </Paper>
            )}
        </>
    );
}

export default QuestionSequenceSolution;
